import { Component, OnInit, OnDestroy } from '@angular/core';
import { StateComponent } from '../state-component.interface';
import { Usdm2Service } from '../../../../services/ai/usdm2.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-activities',
  imports: [],
  templateUrl: './activities.component.html',
  styleUrl: './activities.component.css'
})
export class ActivitiesComponent implements StateComponent, OnInit, OnDestroy {
  stateName = 'Activities';
  private usdmSub: Subscription | null = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any = null;

  constructor(private usdm: Usdm2Service) { }

  ngOnInit(): void {
    this.usdmSub = this.usdm.contentUpdate$.subscribe((item) => {
      if (this.usdm.currentState() == this.stateName && item && item.type === 'OsbUploadResponse') {
        if (item.message.includes('Activity created successfully')) {
          this.data = item.data;
          this.usdm.signalStateCompletion(this.stateName);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.usdmSub?.unsubscribe();
    this.usdmSub = null;
  }

}
